module.exports = __webpack_public_path__ + "static/014_001-e8e72a2357c2cd8ff4b304d6db7a4cdb.jpg";